import * as React from "react";
import { ActionButtonData } from "../models/clientModels/data/actionButtonData";

import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { useNavigate } from "react-router-dom";

type SpeedDialProps = {
  actions: ActionButtonData[];
};

export default function MWSpeedDial({ actions }: SpeedDialProps) {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <SpeedDial
      ariaLabel="Equipment controlled"
      sx={{ position: "fixed", bottom: 16, right: 16 }}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          sx={{ whiteSpace: "nowrap", "& span": { color: "seagreen", fontSize: "12px" } }}
          key={action.id}
          icon={action.icon}
          tooltipTitle={action.caption}
          tooltipOpen
          onClick={() => {
            handleClose();
            if (action && action.link) {
              if (typeof action.link === "string") {
                navigate(action.link);
              } else {
                navigate(action.link);
              }
            }
          }}
        />
      ))}
    </SpeedDial>
  );
}
